export default __webpack_public_path__ + "static/media/blueCircleDollar.8ec01869.svg";